// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__Jx7Xh","checkboxCol":"Table_checkboxCol__22RCd","emailCol":"Table_emailCol__12NUE","actionCol":"Table_actionCol__2ChFt"};